// Skeleton of the ResiRent website
import { Outlet } from 'react-router-dom';
import React from 'react';
import Footer from '../footer/Footer';
import Navbar from './Navbar';

const LayoutDashboard = () => {

    return (
        <main style={{ display: "flex", minHeight: "100vh" }}>
            <div style={{
                width: 260,
                flexShrink: 0,
                position: "sticky",
                top: 0,
                height: "100vh",
                overflowY: "auto",
            }}>
                <Navbar />
            </div>
            <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
                <div style={{ flex: 1 }}>
                    <Outlet />
                </div>
                <Footer />
            </div>
        </main>
    );
}

export default LayoutDashboard;